// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class LegalRequestService {
  public readInputTimeOutDebounce;

  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public getLegalRequestTypeById(typeId: string, context: string): Observable<any> {
    const url = this.Global.services.legalRequest.typeById();
    return this.sendService.get(url, {
      params: { id: typeId, tableName: 'legal-request-type', context },
    });
  }

  public createLegalRequest<T>(body, params): Observable<T> {
    const url = this.Global.services.legalRequest.request();
    return this.sendService.post(url, body, { params });
  }

  public editClaim<T>(body, id): Observable<T> {
    const url = this.Global.services.legalRequest.draft();
    return this.sendService.put(url, body, { params: id });
  }

  public getCorrectionCalculation<T>(params): Observable<T> {
    const url = this.Global.services.monetaryRate.correctionCalculation();
    return this.sendService.get(url, { params });
  }

  public async correctionCalculation({
    dateReference,
    primaryValue,
    primaryIndexId,
    hasInterest,
    hasPenalty,
    interestDateReference,
    interestPercents,
    penaltyPercents,
    dolarQuotation,
  }: any): Promise<any> {
    const startDate = dateReference;
    const endDate = moment().unix();
    const value = parseFloat(primaryValue);
    const indexRateName = primaryIndexId;

    const params = {
      indexRateName,
      value,
      startDate,
      endDate,
      hasInterest,
      hasPenalty,
      interestDateReference,
      interestPercents,
      penaltyPercents,
      dolarQuotation,
    };

    return new Promise((resolve, reject) => {
      this.getCorrectionCalculation(params).subscribe(
        (response: any) => resolve(response),
        (err: any) => {
          reject(err);
          console.error(`error`, err);
        }
      );
    });
  }

  public async calculation(values): Promise<any> {
    return new Promise((resolve) => {
      const {
        primaryValue,
        primaryIndexId,
        risk,
        dateReference,
        interestDateReference,
        interestPercents,
        penaltyPercents,
        hasInterest,
        hasPenalty,
        dolarQuotation,
      } = values;

      let totalRisco = 0; // remoto
      if (risk === 'possivel') totalRisco = 50;
      if (risk === 'provavel') totalRisco = 100;

      if (primaryValue && primaryIndexId) {
        clearTimeout(this.readInputTimeOutDebounce);

        this.readInputTimeOutDebounce = setTimeout(async () => {
          const params = {
            dateReference,
            primaryValue,
            primaryIndexId,
            hasInterest,
            hasPenalty,
            interestDateReference,
            interestPercents,
            penaltyPercents,
            dolarQuotation,
          };

          this.correctionCalculation(params)
            .then((corrections) => {
              let totalUpdated = 0;

              if (corrections.correctedBalance && corrections.correctedBalance !== 'NaN') {
                totalUpdated += Number(corrections.correctedBalance);
              }
              if (corrections.interestValue && corrections.interestValue !== 'NaN') {
                totalUpdated += Number(corrections.interestValue);
              }
              if (corrections.penaltyValue && corrections.penaltyValue !== 'NaN') {
                totalUpdated += Number(corrections.penaltyValue);
              }

              return resolve({
                valTotalInicial:
                  corrections.balance && corrections.balance !== 'NaN'
                    ? String(corrections.balance)
                    : '0.00',
                valTotalAtualizado: totalUpdated.toFixed(2),
                valTotalRisco: ((totalUpdated * totalRisco) / 100).toFixed(2),
              });
            })
            .catch((error) => {
              return resolve({
                valTotalInicial: '0.00',
                valTotalAtualizado: '0.00',
                valTotalRisco: '0.00',
              });
            });
        }, 300);
      } else {
        return resolve({
          valTotalInicial: '0.00',
          valTotalAtualizado: '0.00',
          valTotalRisco: '0.00',
        });
      }
    });
  }
}
